"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function FormFields(_a) {
    var channel = _a.channel, setChannel = _a.setChannel, user = _a.user, submit = _a.submit, type = _a.type;
    var sports = ra_fetch_1.useApi('backend').index('sports')[0];
    var types = ra_fetch_1.useApi('backend').index('types', { table: 'channels' })[0];
    var currentType = types.data.findBy('id', Number(channel.type_id));
    return react_1.default.createElement(react_1.default.Fragment, null,
        user.is_admin && react_1.default.createElement(storybook_1.Forms.Field, { className: 'w-full flex justify-end' },
            react_1.default.createElement(storybook_1.Texts.Span, null, "Publiek"),
            react_1.default.createElement(storybook_1.Forms.Toggle, { name: 'hidden', value: !channel.hidden, placeholder: 'Verberg channel', onClick: function () {
                    var value = { hidden: !channel.hidden };
                    if (channel.id) {
                        submit(value, true).then(function (response) {
                            if (!response.errors.length) {
                                setChannel(value);
                            }
                        });
                    }
                    else {
                        setChannel(value);
                    }
                } })),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Label, null, "Titel"),
            react_1.default.createElement(storybook_1.Forms.Input, { name: 'label', value: channel.label, placeholder: 'Titel', onChange: function (label) { return setChannel({ label: label }); } })),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Label, null, "Slug"),
            react_1.default.createElement("div", { className: 'flex gap-4 items-center' },
                react_1.default.createElement(storybook_1.Texts.Link, null,
                    process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL,
                    "/",
                    type.url,
                    "/"),
                react_1.default.createElement(storybook_1.Forms.Input, { type: 'text', name: 'name', value: channel.name, placeholder: 'Slug', onChange: function (name) { return setChannel({ name: name }); } }))),
        user.is_admin && react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Label, null, "Type"),
            react_1.default.createElement(storybook_1.Forms.Select, { onChange: function (type_id) { return setChannel({ type_id: type_id }); }, value: channel.type_id },
                !channel.type_id && react_1.default.createElement("option", null, "Kies een type"),
                types.data.map(function (types, index) { return react_1.default.createElement("option", { key: index, value: types.id }, types.label); }))),
        currentType.name === 'player' && react_1.default.createElement(storybook_1.Channels.FormTeam, { user: user, channel: channel, setChannel: setChannel }),
        (user.is_admin || !channel.id) &&
            currentType.name &&
            currentType.name !== 'player' &&
            react_1.default.createElement(storybook_1.Forms.Field, null,
                react_1.default.createElement(storybook_1.Forms.Label, null, "Sport"),
                react_1.default.createElement(storybook_1.Forms.Select, { onChange: function (sport_id) { return setChannel({ sport_id: sport_id }); }, value: channel.sport_id },
                    !channel.sport_id && react_1.default.createElement("option", null, "Kies een sport"),
                    sports.data.map(function (sports, index) { return react_1.default.createElement("option", { key: index, value: sports.id }, sports.label); }))),
        user.is_admin && react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Label, null, "Positie"),
            react_1.default.createElement(storybook_1.Forms.Input, { type: 'number', name: 'hidden', value: channel.position, placeholder: 'Verander positie', onChange: function (position) { return setChannel({ position: position }); } })));
}
exports.default = FormFields;
